<template>
  <el-avatar
    :size="size"
    class="staff-avatar"
    :src="compress ? getCompressedUrl(avatar) : avatar"
    :style="userId && userId.length > 3 ? 'background-color: #FF7373' : ''"
  >
    {{ name ? name[0].toUpperCase() : "无" }}
  </el-avatar>
</template>
<script>
import { getCompressedUrl } from "@/utils/common"
export default {
  name: "staff-avatar",
  props: {
    user: Object,
    size: [String, Number],
    compress: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    avatar() {
      return this.user.avatar || this.user.userAvatar
    },
    userId() {
      return this.user.id || this.user.userId
    },
    name() {
      return this.user.name || this.user.username || this.user.label
    }
  },
  methods: {
    getCompressedUrl
  }
}
</script>

<style lang="scss" scoped>
.staff-avatar {
  flex-shrink: 0;
}
</style>
